import { fetchApiPost } from "./utils";

/**
 * Tracked-report types known to the mono-bun registry. Adding a new
 * entry here requires a matching entry in
 * `packages/tracked-reports/src/services/registry.ts`.
 */
export type TrackedReportType =
  | "birthday_fund_granted_exported"
  | "marketing_fee_accrual"
  | "producer_risk_oc_nc";

export interface TrackedReportSourceFileInput {
  filename: string;
  file_type: string;
  meta?: Record<string, string>;
}

export interface TrackedReportOutputFileInput {
  filename?: string;
  file_type: string;
  meta?: Record<string, string>;
}

export interface CreateTrackedReportBody {
  report_type: TrackedReportType;
  files: {
    source: TrackedReportSourceFileInput[];
    output: TrackedReportOutputFileInput[];
  };
}

export interface CreatedTrackedReportFile {
  document_id: string;
  bucket: string;
  key: string;
  filename: string;
  put_url: string;
}

export interface CreatedTrackedReport {
  tracked_report_id: string;
  report_type: string;
  source: CreatedTrackedReportFile[];
  output: CreatedTrackedReportFile[];
}

export function createTrackedReport(body: CreateTrackedReportBody) {
  return fetchApiPost<CreatedTrackedReport>("tracked/reports", body);
}
